'use client';

import { useQueryClient } from '@tanstack/react-query';
import { createTRPCContext } from '@trpc/tanstack-react-query';
import { createTRPCClient, httpBatchStreamLink, loggerLink } from '@trpc/client';
import { useMemo } from 'react';
import SuperJSON from 'superjson';
import type { TRPC_ROUTER } from '~/modules/trpc/routers';
import type { I18N_CONF } from '@funkey/locales/config';
import { CONFIG } from '~/env';
const {
  TRPCProvider: TRPCProviderInternal,
  /** tRPC context to be used with @tanstack/react-query */
  useTRPC,
  /** tRPC context directly call the tRPC routers (like fetch) */
  useTRPCClient
} = createTRPCContext<typeof TRPC_ROUTER>();
export { useTRPC, useTRPCClient };
export function TRPCProvider(props: {
  children: React.ReactNode;
  locale: I18N_CONF.Locale;
}) {
  const qc = useQueryClient();
  const trpcClient = useMemo(() => {
    return createTRPCClient<typeof TRPC_ROUTER>({
      links: [loggerLink({
        enabled: op => process.env.NODE_ENV === 'development' || op.direction === 'down' && op.result instanceof Error
      }), httpBatchStreamLink({
        transformer: SuperJSON,
        url: `${CONFIG.APP_URL}/api/trpc`,
        // We override the HTTP method to support large query input (f.e. for bizz selection with lots of IDs)
        methodOverride: 'POST',
        headers: () => {
          const headers = new Headers();
          headers.set('x-trpc-source', 'nextjs-react');
          headers.set('accept-language', props.locale);
          return headers;
        }
      })]
    });
  }, []);
  return <TRPCProviderInternal trpcClient={trpcClient} queryClient={qc}>
            {props.children}
        </TRPCProviderInternal>;
}